



















































import { computed, defineComponent, ref, PropType } from "@vue/composition-api";
import { PayoutRequestSettings } from "@scrile/api-provider/dist/api/PayoutRequestsProvider";
import { PayoutSystemSettings } from "@scrile/api-provider/dist/api/PayoutSystemSettingsProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString, getCurrencyCode, getCurrencySymbol } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";
import BaseInput from "@/components/BaseInput";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "CreatePayoutRequestModal",
  components: { BaseConfirm, BaseButton, BaseForm, BaseInput, FormatMoney },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    primaryBalance: { type: Number, required: true },
    requestErrorValue: { type: String, required: true },
    payoutSystem: { type: Object as PropType<PayoutSystemSettings | null> },
    requestSettings: { type: Object as PropType<PayoutRequestSettings | null> },
  },
  setup(props, { emit }) {
    const value = ref("");
    const currencySymbol = $t(getCurrencySymbol(getCurrencyCode()));

    const amount = computed(() => {
      const numberValue = Number(value.value);
      return isNaN(numberValue) ? 0 : numberValue;
    });

    const commission = computed(() => {
      const percentCommission = props.payoutSystem?.percentCommission ?? 0;
      const flatCommission = props.payoutSystem?.flatCommission ?? 0;
      return amount.value > 0 ? (amount.value / 100) * percentCommission + flatCommission : 0;
    });

    const requestedAmount = computed(() => amount.value - commission.value);

    const subText = computed(() => {
      if (props.requestErrorValue) {
        return $t(props.requestErrorValue);
      }
      return $t("Minimum withdrawal amount is {0}", [formatMoneyString(props.requestSettings?.minimumAmount ?? 0)]);
    });

    const commissionText = computed(() => {
      return $t("Payout commissions and fees: {0}", [formatMoneyString(commission.value)]);
    });

    const requestButtonText = computed(() => {
      return amount.value ? $t("Request {0}", [formatMoneyString(requestedAmount.value)]) : $t("Request");
    });

    const onAvailableAmount = () => {
      value.value = props.primaryBalance.toString();
      if (props.requestErrorValue) emit("resetErrorValue");
    };

    const onInput = (v: string) => {
      const numberValue = +v;
      if (props.requestErrorValue) emit("resetErrorValue");
      if (isNaN(numberValue) || numberValue === 0) {
        value.value = "";
      } else {
        value.value = numberValue.toString();
      }
    };

    const onCloseModal = () => {
      value.value = "";
      emit("close");
      emit("resetErrorValue");
    };
    const onSubmit = () => {
      emit("submit", value.value);
    };

    return {
      requestedAmount,
      value,
      commissionText,
      requestButtonText,
      currencySymbol,
      subText,
      onInput,
      onAvailableAmount,
      onCloseModal,
      onSubmit,
    };
  },
});
